import { render, staticRenderFns } from "./PositionsSection.vue?vue&type=template&id=63c63350"
import script from "./PositionsSection.vue?vue&type=script&lang=js"
export * from "./PositionsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports